import http from 'hub-http/clients/apiClient';
const BASE_URL = '/forms/app/v1';
const postAddNewFollowUpEmail = (guid, sourceApp, name = '') => http.post(`${BASE_URL}/simple-flow/follow-up-email`, {
  data: Object.assign({
    formGuid: guid,
    sourceApp
  }, name ? {
    name
  } : {})
});
export default postAddNewFollowUpEmail;